<template lang="pug">
    v-card.mx-lg-auto.mt-md-4.mb-md-4(v-if="validProspectService" outlined :width="cardWidth" style="margin: 10px 0px !important;")
        v-toolbar(flat)
            v-btn(
                color="primary"
                icon
                ripple
                @click="showDetails = !showDetails;"
            )
                v-icon(v-if="showDetails === true")
                    | mdi-chevron-down
                v-icon(v-else)
                    | mdi-chevron-right

            v-toolbar-title(style ="font-size: 14px;")
                | {{ vehicleYearMakeModel }}
                br
                span.text-body-2
                    | {{ prospectService.service_ro_number }}
            v-spacer
            .text-caption.text-right.m-l-5
                strong.text-uppercase {{ prospectService.service_date }}
                br
                | {{ prospectService.service_ro_amount | dollar }}
        v-divider
        v-card-text(v-if="showDetails === true")
            v-simple-table
                template(v-slot:default)
                    tbody
                        tr
                            td
                                .text-capitalize.text-overline.text--secondary.text--darken-3 Service Date 
                                .cell-value-spacing(v-if="prospectService.service_date && prospectService.service_date.length > 0") {{ prospectService.service_date }}
                                .cell-value-spacing(v-else) N/a
                        tr
                            td
                                .text-capitalize.text-overline.text--secondary.text--darken-3 Service Ro Number
                                .cell-value-spacing(v-if="prospectService.service_ro_number && prospectService.service_ro_number.length > 0") {{ prospectService.service_ro_number }}
                                .cell-value-spacing(v-else) N/a
                        tr
                            td
                                .text-capitalize.text-overline.text--secondary.text--darken-3 Service Ro Amount
                                .cell-value-spacing(v-if="prospectService.service_ro_amount && prospectService.service_ro_amount.length > 0") {{ prospectService.service_ro_amount | dollar }}
                                .cell-value-spacing(v-else) N/a
                        tr
                            td
                                .text-capitalize.text-overline.text--secondary.text--darken-3 Service Customer Number
                                .cell-value-spacing(v-if="prospectService.service_customer_number && prospectService.service_customer_number.length > 0") {{ prospectService.service_customer_number }}
                                .cell-value-spacing(v-else) N/a
                        tr
                            td
                                .text-capitalize.text-overline.text--secondary.text--darken-3 Vehicle Type
                                .cell-value-spacing(v-if="prospectService.service_vehicle_type && prospectService.service_vehicle_type.length > 0") {{ prospectService.service_vehicle_type }}
                                .cell-value-spacing(v-else) N/a
                        tr
                            td
                                .text-capitalize.text-overline.text--secondary.text--darken-3 Vehicle Model Year
                                .cell-value-spacing(v-if="prospectService.service_vehicle_model_year && prospectService.service_vehicle_model_year.length > 0") {{ prospectService.service_vehicle_model_year }}
                                .cell-value-spacing(v-else) N/a
                        tr
                            td
                                .text-capitalize.text-overline.text--secondary.text--darken-3 Vehicle Make
                                .cell-value-spacing(v-if="prospectService.service_vehicle_make && prospectService.service_vehicle_make.length > 0") {{ prospectService.service_vehicle_make }}
                                .cell-value-spacing(v-else) N/a
                        tr
                            td
                                .text-capitalize.text-overline.text--secondary.text--darken-3 Vehicle Model
                                .cell-value-spacing(v-if="prospectService.service_vehicle_model && prospectService.service_vehicle_model.length > 0") {{ prospectService.service_vehicle_model }}
                                .cell-value-spacing(v-else) N/a
                        tr
                            td
                                .text-capitalize.text-overline.text--secondary.text--darken-3 Vehicle Odometer
                                .cell-value-spacing(v-if="prospectService.service_vehicle_odometer && prospectService.service_vehicle_odometer.length > 0") {{ prospectService.service_vehicle_odometer }}
                                .cell-value-spacing(v-else) N/a
                        tr
                            td
                                .text-capitalize.text-overline.text--secondary.text--darken-3 Vehicle Trim
                                .cell-value-spacing(v-if="prospectService.service_vehicle_trim && prospectService.service_vehicle_trim.length > 0") {{ prospectService.service_vehicle_trim }}
                                .cell-value-spacing(v-else) N/a
                        tr
                            td
                                .text-capitalize.text-overline.text--secondary.text--darken-3 Vehicle Vin
                                .cell-value-spacing(v-if="prospectService.service_vehicle_vin && prospectService.service_vehicle_vin.length > 0") {{ prospectService.service_vehicle_vin }}
                                .cell-value-spacing(v-else) N/a
                        tr
                            td
                                .text-capitalize.text-overline.text--secondary.text--darken-3 Vehicle Exterior Color
                                .cell-value-spacing(v-if="prospectService.service_vehicle_exterior_color && prospectService.service_vehicle_exterior_color.length > 0") {{ prospectService.service_vehicle_exterior_color }}
                                .cell-value-spacing(v-else) N/a
                        tr
                            td
                                .text-capitalize.text-overline.text--secondary.text--darken-3 Vehicle Stock Number
                                .cell-value-spacing(v-if="prospectService.service_vehicle_stock_number && prospectService.service_vehicle_stock_number.length > 0") {{ prospectService.service_vehicle_stock_number }}
                                .cell-value-spacing(v-else) N/a
                        tr
                            td
                                .text-capitalize.text-overline.text--secondary.text--darken-3 Service Vehicle Comments
                                .cell-value-spacing(v-if="prospectService.service_vehicle_comments && prospectService.service_vehicle_comments.length > 0") {{ prospectService.service_vehicle_comments }}
                                .cell-value-spacing(v-else) N/a

</template>

<script lang="ts">
    import Vue from 'vue';

    // Helpers
    import { concatVehicleYearMakeModel } from "@/helpers/general";

    // Types
    import { VehicleYearMakeModelObj } from "@/helpers/general";

    export default Vue.extend({
        data() {
            return {
                cardWidth: 300,
				showDetails: false,
            }
        },
        methods: {
            handleDetailsResize() {
                const detailsWidth = document?.getElementById('prospect-details-card')?.getBoundingClientRect()?.width
                if (detailsWidth >= 375) {
                    this.cardWidth = detailsWidth - 75
                } else {
                    this.cardWidth = 300
                }
            },
        },
        computed: {
            validProspectService() {
                return this.prospectService?.prospect_service_id > 0;
            },
            vehicleYearMakeModel() {
                if (!this.validProspectService) {
                    return null;
                }

                const vehObj = {
                    vehicleModelYear: this.prospectService.service_vehicle_model_year,
                    vehicleMake:      this.prospectService.service_vehicle_make,
                    vehicleModel:     this.prospectService.service_vehicle_model,
                }

                return concatVehicleYearMakeModel(vehObj as VehicleYearMakeModelObj);
            },
        },
        props: {
            prospectService: Object,
        },
        watch: {
            prospectService: {
                handler() {
                    Vue.nextTick(() => { this.handleDetailsResize(); });
                },
                deep: true,
            },
        },
        created() {
			window.addEventListener('resize', this.handleDetailsResize);
        },
        destroyed() {
            window.removeEventListener('resize', this.handleDetailsResize);
        },
        mounted() {
            this.handleDetailsResize();
        },
    });
</script>

<style lang="scss" scoped>
    #app {
        .cell-value-spacing {
            padding: 0 0 5px 0;
        }
    }
</style>
